const ContactPageSchema = ({
  name,
  description,
  url
}) => ({
  "@context": "https://schema.org",
  "@type": "ContactPage",
  "@id": `${url}#webpage`,
  "url": url,
  "name": name,
  "description": description,
  "isPartOf": {
    "@id": "https://onbbits.io/#website"
  },
  "about": {
    "@id": "https://onbbits.io/#organization"
  },
  "publisher": {
    "@id": "https://onbbits.io/#organization"
  }
});

export default ContactPageSchema;